<template>
	<section class="page page-logout"></section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';
	import { mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageLogout extends PageBase {
		/**
		 * @return void
		 */
		@mounted
		public logout(): void {
			// Logout
			this.$store.dispatch('authentication/logout');

			// Redirect home
			location.href = '/';
		}
	}
</script>
